import api from './axiosConfig';

// Call backend register to register a new user
export const registerUser = async (userData) => {
  try {
    const response = await api.post('/users/register', userData);
    console.log('User registered successfully', response.data);
    return response.data;
  } catch (error) {
    console.error('Error registering user', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Call backend login to login a user
export const loginUser = async (userData) => {
  try {
    const response = await api.post('/users/login', userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Call backend getAllUsers to get all users
export const getAllUsers = async () => {
  try {
    const response = await api.get('/users/getAllUsers');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getDistributorOrganizations = async () => {
  try {
    const response = await api.get('/users/distributor-organizations');
    return response.data;
  } catch (error) {
    console.error('Error fetching distributor organizations:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const changeRole = async(userData) => {
  try {
    const response = await api.post('/users/changeRole', userData);
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const changeStatus = async(userData) => {
  try {
    const response = await api.post('/users/changeStatus', userData);
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const changePassword = async(userData) => {
  try {
    const response = await api.post('/users/changePassword', userData);
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export const emailSubscribe = async(userData) => {
  try {
    const response = await api.post('/users/emailSubscribe', userData);
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export const deleteUser = async(userData) => {
  try {
    const response = await api.delete('/users/deleteUser', { data: userData });
    return response.data;
  } catch (error) {
    console.error('Error response:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}
